import {
  SET_IS_START_BUYER,
  SET_IS_FAILED_BUYER,
  SET_IS_SUCCESS_BUYER,
  SET_IS_NEED_TO_RELOAD_BUYER,
  SET_PAGINATION_DATA_BUYER,
  SET_IS_SUCCESS_BUYERPOINTS_BUYER,
  SET_PAGINATION_DATA_BUYERPOINTS_BUYER,
  SET_DETAILS_ORDER_DATA_BUYERPOINTS_BUYER,
  SET_IS_SUCCESS_ASTROSALDOHISTORY_BUYER,
  SET_IS_SHOW_MODAL_INJECT_SALDO_BUYER,
  SET_FORM_MODAL_INJECT_SALDO_BUYER,
  SET_IS_SHOW_MODAL_CONFIRMATION_INJECT_SALDO_BUYER,
  RESET_FORM_MODAL_INJECT_SALDO_BUYER,
} from 'storeContext/actionsType/buyer'

export type BuyerPaginationType = {
  currentItem: number
  currentPage: number
  pageSize: number
  totalData: number
  totalPage: number
}

export type BuyerListItemType = {
  customer_id: number
  customer_first_name: string
  customer_last_name: string
  customer_is_fraud: boolean
  customer_referral_code: string
  customer_phone_number: string
  customer_email: string
  customer_refund_point: number
  customer_point: number
  customer_active: boolean
}

export type BuyerPointsListItemType = {
  type_transaction: string
  point_created_at: string
  type_point: string
  point_title: string
  point_description: string
  point_amount: number
  order_id: number
  order_invoice: string
}

export type AstroSaldoHistoryItemType = {
  id: number
  created_at: number
  type_transaction: string
  title: string
  description: string
  balance_type_fmt: string
  amount: number
  order_id: number
}

export type BuyerPointsOrderLineItemType = {
  order_product_rack: string
  order_product_name: string
  order_product_sku: string
  order_product_quantity: number
  order_product_actual_quantity: number
}

export type BuyerPointsActivityType = {
  activity_created_at: string
  activity_status: boolean
  activity_name: string
  driver_url_photo?: string | null
  driver_note?: string | null
  driver_full_name?: string | null
}

export type BuyerPointsCustomerAddressType = {
  customer_name: string
  customer_phone_number: string
  customer_address_place: string
  customer_address_detail: string
  customer_address_description: string
  customer_address_instruction: string
}

export type BuyerPointsDetailType = {
  order_payment_method?: string
  order_point_amount?: number
  order_voucher_code?: string | null
  order_created_at?: string
  order_invoice?: string
  order_customer_address?: Partial<BuyerPointsCustomerAddressType>
  order_line_items?: BuyerPointsOrderLineItemType[]
  order_history?: BuyerPointsActivityType[]
}

export type BuyerFormModalInjectSaldoType = {
  nominal: number
  orderId: string
  action: { name: string; value: string }
  notes: string
}

export type BuyerFormModalInjectSaldoPayloadType = {
  name: string
  value: string | number | { name: string; value: string }
}

export interface BuyerStateInterface {
  isLoading: boolean
  buyerData: BuyerListItemType[]
  paginationData: Partial<BuyerPaginationType>
  buyerSaldoAstroHistoryData: AstroSaldoHistoryItemType[]
  buyerPointsData: BuyerPointsListItemType[]
  buyerPointsPaginationData: Partial<BuyerPaginationType>
  buyerPointsDetailsData: BuyerPointsDetailType
  buyerPointsStatusDetailsData: boolean
  needToReload: number
  isShowModalInjectSaldo: boolean
  formModalInjectSaldo: BuyerFormModalInjectSaldoType
  isShowModalConfirmationInjectSaldo: boolean
}

type BuyerActionType =
  | { type: typeof SET_IS_START_BUYER }
  | { type: typeof SET_IS_FAILED_BUYER }
  | { type: typeof SET_IS_SUCCESS_BUYER; payload: { content: BuyerListItemType[] } }
  | { type: typeof SET_IS_NEED_TO_RELOAD_BUYER }
  | { type: typeof SET_PAGINATION_DATA_BUYER; payload: BuyerPaginationType }
  | {
      type: typeof SET_IS_SUCCESS_BUYERPOINTS_BUYER
      payload: { content: BuyerPointsListItemType[] }
    }
  | { type: typeof SET_PAGINATION_DATA_BUYERPOINTS_BUYER; payload: BuyerPaginationType }
  | { type: typeof SET_DETAILS_ORDER_DATA_BUYERPOINTS_BUYER; payload: BuyerPointsDetailType }
  | { type: typeof SET_IS_SUCCESS_ASTROSALDOHISTORY_BUYER; payload: AstroSaldoHistoryItemType[] }
  | { type: typeof SET_IS_SHOW_MODAL_INJECT_SALDO_BUYER; payload: boolean }
  | {
      type: typeof SET_FORM_MODAL_INJECT_SALDO_BUYER
      payload: BuyerFormModalInjectSaldoPayloadType
    }
  | { type: typeof SET_IS_SHOW_MODAL_CONFIRMATION_INJECT_SALDO_BUYER; payload: boolean }
  | { type: typeof RESET_FORM_MODAL_INJECT_SALDO_BUYER }

export const initialStateBuyer: BuyerStateInterface = {
  isLoading: false,
  buyerData: [],
  paginationData: {},
  buyerSaldoAstroHistoryData: [],
  buyerPointsData: [],
  buyerPointsPaginationData: {},
  buyerPointsDetailsData: {},
  buyerPointsStatusDetailsData: false,
  needToReload: 1,
  isShowModalInjectSaldo: false,
  formModalInjectSaldo: {
    nominal: 0,
    orderId: '',
    action: { name: '', value: '' },
    notes: '',
  },
  isShowModalConfirmationInjectSaldo: false,
}

export default function buyer(state = initialStateBuyer, action: BuyerActionType) {
  switch (action.type) {
    case SET_IS_START_BUYER:
      return {
        ...state,
        isLoading: true,
      }
    case SET_IS_FAILED_BUYER:
      return {
        ...state,
        isLoading: false,
      }
    case SET_IS_SUCCESS_BUYER:
      return {
        ...state,
        isLoading: false,
        buyerData: action.payload.content,
      }
    case SET_IS_NEED_TO_RELOAD_BUYER:
      return {
        ...state,
        needToReload: state.needToReload + 1,
      }
    case SET_PAGINATION_DATA_BUYER:
      return {
        ...state,
        paginationData: action.payload,
      }
    case SET_IS_SUCCESS_BUYERPOINTS_BUYER:
      return {
        ...state,
        isLoading: false,
        buyerPointsData: action.payload.content,
      }
    case SET_IS_SUCCESS_ASTROSALDOHISTORY_BUYER:
      return {
        ...state,
        isLoading: false,
        buyerSaldoAstroHistoryData: action.payload,
      }
    case SET_PAGINATION_DATA_BUYERPOINTS_BUYER:
      return {
        ...state,
        buyerPointsPaginationData: action.payload,
      }
    case SET_DETAILS_ORDER_DATA_BUYERPOINTS_BUYER:
      return {
        ...state,
        buyerPointsDetailsData: action.payload,
        buyerPointsStatusDetailsData: true,
      }
    case SET_IS_SHOW_MODAL_INJECT_SALDO_BUYER:
      return {
        ...state,
        isShowModalInjectSaldo: action.payload,
      }
    case SET_FORM_MODAL_INJECT_SALDO_BUYER:
      return {
        ...state,
        formModalInjectSaldo: {
          ...state.formModalInjectSaldo,
          [action.payload.name]: action.payload.value,
        } as BuyerFormModalInjectSaldoType,
      }
    case SET_IS_SHOW_MODAL_CONFIRMATION_INJECT_SALDO_BUYER:
      return {
        ...state,
        isShowModalConfirmationInjectSaldo: action.payload,
      }
    case RESET_FORM_MODAL_INJECT_SALDO_BUYER:
      return {
        ...state,
        formModalInjectSaldo: initialStateBuyer.formModalInjectSaldo,
      }
    default:
      return state
  }
}
